import {mapMutations} from 'vuex';

export default {
    name: 'shop-item',
    props: {
        index: {
            type: Number
        },
        item: {
            type: Object
        }
    },
    data() {
        return {
            active: false,
            digitsVisible: false,
            radius: 15,
        }
    },
    computed: {
        lastUserLessonSlug() {
            return this.item.userCourse.data.hasOwnProperty('currentMaterial')
                ? this.item.userCourse.data.currentMaterial.data.hasOwnProperty('id')
                    ? this.item.userCourse.data.currentMaterial.data.slug
                    : null
                : null
        },

        lastUserModuleSlug() {
            return this.item.userCourse.data.hasOwnProperty('currentMaterial')
                ? this.item.userCourse.data.currentMaterial.data.hasOwnProperty('id')
                    ? this.item.userCourse.data.currentMaterial.data.module.data.slug
                    : null
                : null
        },
        progress() {
            return Math.round((100 / this.item.course.data.materialsCount) * this.item.userCourse.data.completedMaterials);
        },
    },
    methods: {
        ...mapMutations({
            changePopup: 'popups/CHANGE_POPUP_TRAILER'
        }),

        routeToCourseMaterial(item) {
            if (item.currentMaterial.data.material === 'lesson') {
                this.$router.push({
                    name: 'courses-lesson-detail',
                    params: {
                        item: this.item.course.data.slug,
                        moduleSlug: item.currentMaterial.data.module.data.slug,
                        lessonSlug: item.currentMaterial.data.slug
                    }
                })
            } else {
                this.$router.push({
                    name: 'home-work-rules',
                    params: {
                        item: this.item.course.data.slug,
                        moduleSlug: item.currentMaterial.data.module.data.slug,
                        testId: item.currentMaterial.data.slug
                    }
                })
            }
        },

        changeBtnStart(item, curItem) {
            switch (item.status) {
                case 'new':
                    if (item.currentMaterial.data.length) {
                        this.routeToCourseMaterial(item);
                    } else {
                        this.$router.push({
                            name: 'courses-main',
                            params: {item: curItem.slug}
                        })
                    }
                    break;
                case 'processing':
                    if (item.currentMaterial) {
                        this.routeToCourseMaterial(item);

                    } else {
                        this.$router.push({
                            name: 'courses-main',
                            params: {item: item.course.data.slug}
                        })
                    }

                    break;
                case 'completed':
                    this.$router.push({
                        name: 'courses-main',
                        params: {item: item.course.data.slug}
                    })
                    break;
            }
        },

        formattedTime(time, key = 'default') {
            const hours = Math.floor(time / 60);
            const minutes = time % 60;
            if (key === 'default') {
                return `${hours < 10 ? '0' + hours : hours} ${this.$t('smHour')} ${minutes < 10 ? '0' + minutes : minutes} ${this.$t('smMinutes')}`
            } else {
                return `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:00`
            }
        },
        changePopupTrailer(item, status) {
            if (!item.trailerUrl) return;
            this.changePopup({
                show: status,
                url: item.trailerUrl,
                provider: item.trailerProvider
            })
        },
        declensionWordLesson(count) {
            let titles = [this.$t('lessonWord1'), this.$t('lessonWord2'), this.$t('lessonWord3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
        declensionWordModule(count) {
            let titles = [this.$t('moduleWord1'), this.$t('moduleWord2'), this.$t('moduleWord3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
        declensionWordStep(count) {
            let titles = [this.$t('stepWord1'), this.$t('stepWord2'), this.$t('stepWord3')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[(count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
        },
    }
}
